export default __webpack_public_path__ + "static/tokens-7093174cbf079dd60aa372ff2628af75.svg";